// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q6-6";
export var imgContainer = "_q6-3";
export var menuIcon = "_q6-5";
export var pillWrapper = "_q6-2";
export var pillsContainer = "_q6-1";
export var subscriptionCard = "_q6-0";
export var subscriptionLogo = "_q6-4";